/*
 * PUT a Blob to a presigned S3 URL, reporting upload progress.
 */
export default function uploadWithProgress(
  url,
  body,
  { contentType, onProgress, signal, timeoutMs = 60000 } = {},
) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new Error("UPLOAD_ABORTED"));
      return;
    }

    const xhr = new XMLHttpRequest();
    let settled = false;

    const onAbortSignal = () => xhr.abort();

    const cleanup = () => {
      settled = true;
      signal?.removeEventListener("abort", onAbortSignal);
    };

    const fail = (error) => {
      if (settled) return;
      cleanup();
      reject(error);
    };

    xhr.open("PUT", url, true);
    if (contentType) xhr.setRequestHeader("Content-Type", contentType);
    xhr.timeout = timeoutMs;

    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        // Without lengthComputable there is nothing honest to report, so leave
        // the caller on whatever it last showed rather than faking a number.
        if (e.lengthComputable && e.total > 0) onProgress(e.loaded / e.total);
      };
    }

    xhr.onload = () => {
      if (settled) return;
      cleanup();
      if (xhr.status >= 200 && xhr.status < 300) {
        if (onProgress) onProgress(1);
        resolve();
      } else {
        reject(new Error(`UPLOAD_FAILED_${xhr.status}`));
      }
    };

    xhr.onerror = () => fail(new Error("UPLOAD_NETWORK_ERROR"));
    xhr.ontimeout = () => fail(new Error("UPLOAD_NETWORK_ERROR"));
    xhr.onabort = () => fail(new Error("UPLOAD_ABORTED"));

    signal?.addEventListener("abort", onAbortSignal);

    xhr.send(body);
  });
}
